import { AxiosResponse } from 'axios';
import { GeometryObject } from 'geojson';
import v3 from '../v3';
import v1 from '../v1';

export async function create(coordinates: ILngLat | ILngLat[] | ILngLat[][] | ILngLat[][][]): Promise<AxiosResponse<{
  _id: string;
}>> {
  return await v3({
    method: 'post',
    url: '/operation.parkingLot',
    data: {
      coordinates,
    },
  });
}

export async function updateById(id: string, coordinates: ILngLat | ILngLat[] | ILngLat[][] | ILngLat[][][]): Promise<AxiosResponse<{
  _id: string;
}>> {
  return await v3({
    method: 'put',
    url: `/operation.parkingLot/id/${id}/polygon`,
    data: {
      coordinates,
    },
  });
}

export async function findInBoundary<T extends GeometryObject>(boundary: [ILngLat, ILngLat]): Promise<AxiosResponse<Array<{
  _id: string;
  polygon: {
    hash: string;
    geometry: T;
    gcj02Geometry: T;
  };
  region: {
    _id:string;
    name:string;
  };
}>>> {
  return await v3({
    method: 'get',
    url: '/operation.parkingLot/inBoundary',
    params: {
      boundary,
    },
  });
}

export async function removeById(id: string): Promise<AxiosResponse<void>> {
  return await v3({
    method: 'delete',
    url: `/operation.parkingLot/id/${id}`,
  });
}

export async function updateRatedParkingCapacity(parkingLotId: string, ratedParkingCapacity: number) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/updateRatedParkingCapacity`,
    data: { ratedParkingCapacity },
  });
}

export async function updateHasBluetoothSpike(parkingLotId: string, hasBluetoothSpike: boolean) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/updateHasBluetoothSpike`,
    data: { hasBluetoothSpike },
  });
}

// 修改预留车辆的启用
export async function updateEnableOverageLimit(parkingLotId: string, enableOverageLimit: boolean) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/updateEnableOverageLimit`,
    data: { enableOverageLimit },
  });
}

// 修改预留车辆的数量
export async function updateOverageLimitCount(parkingLotId: string, overageLimitCount: number) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/updateOverageLimitCount`,
    data: { overageLimitCount },
  });
}

// 修改积压车辆的数量
export async function updateStockBacklogAlarmCount(parkingLotId: string, stockBacklogAlarmCount: number) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/updateStockBacklogAlarmCount`,
    data: { count: stockBacklogAlarmCount },
  });
}

// 修改小于多少台车触发告警
export async function updateStockBelowAlarmCount(parkingLotId: string, count: number) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/updateStockBelowAlarmCount`,
    data: { count },
  });
}

// 修改停车区名称
export async function updateParkingNameAndSave(parkingLotId: string, name: string) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/update`,
    data: { name },
  });
}

// 修改停车区排序（同时传递name字段）
export async function updateParkingSortAndSave(parkingLotId: string, sort: number, name: string) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/update`,
    data: { sort, name },
  });
}

// 清除虚拟群组的绑定
export async function clearVirtualGroupLink(parkingLotId: string) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/${parkingLotId}/clearVirtualGroupLink`,
  });
}

// 获取虚拟分组的详细信息
export async function getVirtualGroupData(virtualGroupId: string) {
  return await v1({
    method: 'get',
    url: `/operation/parkingLot/virtualGroup`,
    params: { id: virtualGroupId },
  });
}

// 创建虚拟分组
export async function createNewVirtualGroup(data: Record<string, any>) {
  return await v1({
    method: 'post',
    url: `/operation/parkingLot/virtualGroup`,
    data,
  });
}

// 修改虚拟分组
export async function updateVirtualGroup(data: Record<string, any>) {
  return await v1({
    method: 'put',
    url: `/operation/parkingLot/virtualGroup`,
    data,
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/geojson.ts